<template>
    <card :item="item" :type="type">
        <div class="cardbody color6" @click.stop="goDetails(item)">
            <div class="header color3">
                <div class="header-title single_hide color3">{{ item.workName }}</div>
                <div style="font-size:16px">
                    <span class="colorf60">{{ item.salaryTypeName }}</span>
                </div>
            </div>
            <div class="content">
                <div class="item_tag">
                    <span class="tagItem">{{ item.industryName }}/{{ item.categoryName }}</span>
                </div>
                <el-row :gutter="20">
                    <el-col :span="8" class="item_text single_hide">
                        <span class="color6">用工人数:</span>
                        <span class="color3">{{item.employmentNumber ? item.employmentNumber + "人" : "--"}}</span>
                    </el-col>
                    <el-col :span="8" class="item_text single_hide">
                        <span class="color6">联系人:</span>
                        <span class="color3">{{item.contactName ? item.contactName : "--"}}</span>
                    </el-col>
                    <el-col :span="8" class="item_text single_hide">
                        <span class="color6">联系电话:</span>
                        <span class="color3">{{item.contactNumber ? ShowPhone(item.contactNumber) : "--"}}</span>
                    </el-col>
                </el-row>
            </div>
            <div class="address color6 single_hide">
                <img src="@/assets/team/locationIcon.png" alt="" />
                <span style="margin-left: 5px" class="color6">{{item.areaName?item.provinceName + item.cityName + item.areaName:item.provinceName + item.cityName}}</span>
                <span v-if="item.updateTime===item.createTime" class="createTime color6">{{item.createTime | formatDate}}发布</span>
                <span v-else class="createTime color6">{{item.updateTime | formatDate}}更新</span>
            </div>
        </div>
    </card>
</template>

<script>
import { apiResignAll } from "@/api/apiResignAll"
import {checkDataStatusMessage} from "@/utils/checkDataStatus";
export default {
    name: "cardLabor",
    components: {
        card: () => import("@/components/card/card")
    },
    inject:['cardListCom'],
    props: {
        item: Object,
        type: Number, // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
    },
    methods: {
    //隐藏电话
    ShowPhone(phone) {
      if (phone && phone.length === 11) {
        const number = `${phone.slice(0, 3)}****${phone.slice(7, 11)}`
        return number
      }else{
        return '/'
      }
    },
        //跳转详细
        async goDetails(item) {
          let type=await checkDataStatusMessage.call(this,this.type,item.no);
          if(type!=1){return;}
            let res = await apiResignAll.getIsEnable(item.no)
            if (res.data.code == 200 && res.data.data.isEnable) {
              let routeUrlC = `/labourService?no=${item.no}`
              window.open(routeUrlC, "_blank");
              /*this.$router.push({
                path: "/labourService",
                query: {
                      no: item.no
                }
              })*/
            } else {
              this.$emit("getList")
              this.$message.warning("该劳务用工已招满，请重新选择")
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.cardbody {
    cursor: pointer;
    .header {
        padding: 0px 10px;
        background: #f5f7fa;
        border-bottom: 1px solid #e4e7ed;
        height: 34px;
        line-height: 34px;
        display: flex;
        justify-content:space-between;
        align-items: center;
        .header-title {
            max-width: 360px;
            font-size: 16px;
            margin-right: 10px;
        } 
    }
    .content {
        padding: 10px;
       .item_tag {
            margin-bottom: 10px;
            display: flex;
            .tagItem {
                height: 24px;
                line-height: 24px;
                background: rgba(2, 134, 223, 0.1);
                color: #0286df;
                font-size: 12px;
                margin-right: 10px;
                padding: 0 5px;
            }
        }
    }
}
.address {
    position: relative;
    border-top: 1px dashed #e4e7ed;
    padding-left: 10px;
    height: 34px;
    line-height: 34px;
    img {
        vertical-align: middle;
        margin-top: -4px;
    }
    .createTime{
        position: absolute;
        right: 15px;
    }
}
.single_hide {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
div {
    box-sizing: border-box;
}
.color6 {
    color: #666666;
}
.color3 {
    color: #333333;
}
</style>
